import SeoMetaHead from '@components/common/seo-meta-head';
import { IPerformer } from '@interfaces/performer';
import { performerService } from '@services/performer.service';
import { Button, Result, message } from 'antd';
import { useRouter } from 'next/router';
import nextCookie from 'next-cookies';
import { useEffect, useState } from 'react';
import { NextPageContext } from 'next/types';
import {
  ContactsOutlined,
  HomeOutlined
} from '@ant-design/icons';
import { IError } from '@interfaces/setting';
import ProfileContainer from '@components/performer/profile/profile-container';
import { getIpFromHeaders } from '@lib/request';
import { publicRuntimeConfig } from '@lib/config';

type IProps = {
  performer: IPerformer;
  previousRoute: string;
  error: IError;
};

function Profile({
  performer, previousRoute, error
}: IProps) {
  const router = useRouter();
  const [err, setErr] = useState(error);

  useEffect(() => {
    if (router.query.msg) {
      message.info(router.query.msg);
    }
    if (error || (router.query.message && router.query.statusCode)) {
      setErr({
        statusCode: error?.statusCode || parseInt(`${router.query.statusCode || '404'}`, 10),
        message: (error?.message || router.query.message) as string
      });
    }
  }, [router.query, error]);

  if (err) {
    return (
      <Result
        status={err?.statusCode as any || 404}
        title={err?.message || 'Not found'}
      />
    );
  }

  return (
    <>
      <SeoMetaHead
        canonicalUrl={`${publicRuntimeConfig.SITE_URL}${router.asPath}`}
        item={performer}
        imageUrl={performer?.avatar}
      />
      <ProfileContainer
        performer={performer}
        previousRoute={previousRoute}
      />
    </>
  );
}

Profile.authenticate = false;
Profile.noredirect = false;

export const getServerSideProps = async (ctx: NextPageContext) => {
  try {
    const { query } = ctx;
    const { token } = nextCookie(ctx);
    const headers = {
      Authorization: token || '',
      'x-client-ip': getIpFromHeaders(ctx.req)
    };
    const { data: performer } = await performerService.findOne(`${query.profileId}?fromServerRequest=true`, headers);
    const previousRoute = ctx?.req?.headers?.referer || null;
    return {
      props: {
        performer,
        previousRoute
      }
    };
  } catch (e) {
    return {
      props: {
        error: await e
      }
    };
  }
};

export default Profile;
